import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Slash as NopeIcon, AlertCircle } from 'react-feather';
import { danger, success, warn, orange, PVLightGray } from '@pv/common/colors';

const AlertIcon = () => (
  <AlertCircle
    color={orange.backgroundColor}
    size={16}
    style={{ flexShrink: 0 }}
  />
);

const ErrorIcon = () => (
  <NopeIcon
    color={danger.backgroundColor}
    size={16}
    style={{ flexShrink: 0 }}
  />
);

interface Space {
  id: string;
  name: string;
  ignoreConflicts: boolean;
}

interface SpaceAvailability {
  [key: string]: 'available' | 'soft_block' | 'hard_block';
}

interface SpaceChipProps {
  space: Space;
  spaceAvailability?: SpaceAvailability;
}

export const SpaceChip = ({ space, spaceAvailability }: SpaceChipProps) => {
  let chipStyles;
  let icon;
  const availability = spaceAvailability?.[space.id];
  const ignoreConflicts = space.ignoreConflicts;
  if (ignoreConflicts) {
    chipStyles = {
      background: 'transparent',
      color: 'text.primary',
      border: `1px solid ${PVLightGray}`,
    };
    icon = <></>;
  } else if (
    !spaceAvailability ||
    !availability ||
    availability === 'soft_block'
  ) {
    chipStyles = {
      background: warn.backgroundColorLight,
      color: warn.textColor,
      borderColor: warn.textColor,
    };
    icon = <AlertIcon />;
  } else if (availability === 'available') {
    chipStyles = {
      background: success.backgroundColorLight,
      color: success.textColor,
      borderColor: success.textColor,
    };
    icon = <></>;
  } else if (availability === 'hard_block') {
    chipStyles = {
      background: danger.backgroundColorLight,
      color: danger.textColor,
      borderColor: danger.textColor,
    };
    icon = <ErrorIcon />;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        ...chipStyles,
        borderRadius: '50px',
        maxWidth: '100%',
        minWidth: 0,
        overflow: 'hidden',
        padding: '4px 12px',
        gap: '8px',
        maxHeight: '26px',
      }}
    >
      <Typography
        variant="body2"
        noWrap
        sx={{
          flexGrow: 1,
          minWidth: 0,
          lineHeight: '18px',
          fontSize: '13px',
        }}
      >
        {space.name}
      </Typography>
      {icon}
    </Stack>
  );
};
